<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>New Payment Receipt</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn text to="/customer-receipts">
          <v-icon left>mdi-arrow-left</v-icon>Back
        </v-btn> -->
      </v-toolbar>

      <v-card-text>
        <v-form ref="receiptForm" v-model="valid" :lazy-validation="lazy">
          <v-row dense class="subtitle-2 text--primary mb-2">
            <v-col cols="12" md="4">
              <v-autocomplete v-model="record.CustomerId" :items="customers" item-text="Name" item-value="id"
                label="Select Customer" outlined dense clearable :search-input.sync="searchCustomers"
                @change="fetchInvoices(record.CustomerId)" :rules="inputRules"></v-autocomplete>

              <div class="mt-2 style-18">Current Bal: {{ currentBalance | currency }}</div>

              <div class="mt-2 style-18">Receipt No:</div>
              <br />

              <div style="margin-top: 10px">
                <DatePicker style="margin-top: 10px" v-if="canBackDate == 'Y'" @date="setDate" :myDate="date"
                  :title="`Date`" ref="dateRef"></DatePicker>
                <span v-else class="style-16">Date: {{ date }}</span>
              </div>
            </v-col>
            <!-- end of col 1 -->

            <!-- start of col 2 -->
            <v-col cols="12" md="4" class="px-4">
              <v-text-field type="number" autocomplete="off" outlined dense label="Amount Paid"
                v-model="record.AmountPaid" :rules="inputRules"></v-text-field>

              <v-autocomplete class="mt-2" v-model="record.AccountId" :items="accounts" item-text="Name" item-value="id"
                label="Bank Account" outlined dense clearable :rules="inputRules"></v-autocomplete>

              <v-autocomplete class="mt-2" v-model="record.PaymentModeId" :items="paymentModes" item-text="Name"
                item-value="id" label="Payment Mode" outlined dense clearable></v-autocomplete>

              <v-text-field class="mt-2" autocomplete="off" outlined dense label="Ref NO:"
                v-model="record.RefNo"></v-text-field>
            </v-col>

            <!-- start of col 3 -->

            <v-col cols="12" md="4">
              <v-textarea rows="2" outlined dense label="Description / Comments" v-model="record.Narration"
                class="mb-2"></v-textarea>

              <div class="mt-2">
                <DatePicker class="mt-2" @date="setChequeDate" :myDate="record.ChequeDate"
                  :title="`Select Cheque Date`"></DatePicker>
              </div>

              <div class="mt-2">
                <DatePicker @date="setBankDate" :myDate="record.BankDate" :title="`Select Bank Date`"></DatePicker>
              </div>
            </v-col>
          </v-row>

          <v-row class="subtitle-2 text--primary">
            <v-col cols="12">
              <v-radio-group dense label="Payment Option:" v-model="PaymentOption" row>
                <v-radio label="Autoclear Invoices" value="C"></v-radio>
                <!-- <v-radio label="Allocate Invoices" value="A"></v-radio>
                <v-radio label="Post Unallocated / deposits" value="U"></v-radio> -->
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row style="background-color: #E9EAEC" class="subtitle-2 text--primary" v-if="PaymentOption == 'A'">
            <v-col cols="12">
              <v-data-table dense v-model="selected" hide-default-footer :items-per-page="pageItems" :headers="headers"
                :items="invoices" :search="search" :mobile-breakpoint="zeroValue" item-key="InvoiceId" show-select>
                <!--  template -->
                <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal && item.DocTotal | currency }}</template>
                <!-- end -->

                <!-- template -->
                <template v-slot:item.TotalPaid="{ item }">{{ item.TotalPaid && item.TotalPaid | currency }}</template>
                <!-- end -->

                <!-- template -->
                <template v-slot:item.Balance="{ item }">{{ item.Balance && item.Balance | currency }}</template>
                <!-- end -->

                <!-- template -->
                <template v-slot:item.DocDate="{ item }">{{ item.DocDate && item.DocDate | date }}</template>
                <!-- end -->
              </v-data-table>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-row class="mt-2 subtitle-2 text--primary">
            <v-col cols="12" md="6" v-if="PaymentOption == 'A'">
              <span class="style-16">Selected Invoices</span>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Invoice No</th>
                      <th class="text-left">Invoice Amount</th>
                      <th class="text-left">Invoice Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="item in selected" :key="item.InvoiceId">
                      <td>{{ item.DocNum }}</td>
                      <td>
                        <span class="custom-accent">{{ item.DocTotal | currency }}</span>
                      </td>
                      <td>{{ item.DocDate | date }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>

            <v-col cols="12">
              <div class="mt-4 mb-2 style-24 float-right">Amount Paid: {{ record.AmountPaid ?
                (parseFloat(record.AmountPaid).toLocaleString()) : 0.0}}</div>
              <br />
              <br />
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-row class="mt-1">
            <v-col cols="12">
              <v-btn color="primary" class="mt-1 float-right" @click="sendData" :loading="$store.state.btnLoader"
                :disabled="$store.state.btnLoader">
                <v-icon left>mdi-content-save</v-icon>Receive Payment
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {},
  data: () => ({
    record: {},
    valid: false,
    lazy: false,
    currentBalance: 0,
    selected: [],
    selectedCustomer: null,
    searchCustomers: null,
    paymentModes: [],
    customers: [],
    accounts: [],
    pageItems: 100,
    zeroValue: 0,
    totalDebt: 0,
    search: "",
    PaymentOption: "C",
    invoices: [],
    date: null,
    inputRules: [v => !!v || "Required"],
    headers: [
      { text: "Invoice No", value: "DocNum" },
      { text: "Total", value: "DocTotal" },
      { text: "Amount Paid", value: "TotalPaid" },
      { text: "Balance", value: "Balance" },
      { text: "Date", value: "DocDate" }
    ],
    debtors: []
  }),
  computed: {
    canBackDate() {
      return localStorage.getItem("canBackDate");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    userRole() {
      return localStorage.getItem("userRole");
    }
  },
  watch: {
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    }
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    setChequeDate(date) {
      this.record.ChequeDate = date;
    },
    setBankDate(date) {
      this.record.BankDate = date;
    },
    sendData() {
      if (!this.$refs.receiptForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      console.log(this.date, " date ");
      if (this.date == null && this.canBackDate == "Y") {
        this.$refs.snackbar.show("Please select payment date", "red");
        return;
      }

      if (this.PaymentOption == undefined) {
        this.$refs.snackbar.show("Please select payment option", "red");
        return;
      }

      if (this.PaymentOption == "A" && this.selected.length == 0) {
        this.$refs.snackbar.show("Please select invoices to allocate payment", "red");
        return;
      }

      if (this.PaymentOption == "U") {
        this.$refs.snackbar.show("This payment option are under development", "orange");
        return;
      }

      if (this.record.AmountPaid > this.currentBalance) {
        this.$refs.snackbar.show("You cannot pay more than the customer balance", "red");
        return;
      }

      // date handling
      var saleDate = new Date().toISOString().substr(0, 10)

      if (this.canBackDate == "Y") {
        saleDate = this.date;
      }

      if (this.record.ChequeDate == undefined || this.record.ChequeDate == null) {
        this.record.ChequeDate = saleDate;
      }

      if (this.record.BankDate == undefined || this.record.BankDate == null) {
        this.record.BankDate = saleDate;
      }

      var invoices = this.selected;
      var selectedIds = [];
      for (const invoice of invoices) {
        selectedIds.push(invoice.InvoiceId);
      }


      var data = {
        AccountId: parseInt(this.record.AccountId),
        AmountPaid: parseFloat(this.record.AmountPaid),
        RequestDocDate: saleDate,
        RequestBankDate: this.record.BankDate,
        RequestChequeDate: this.record.ChequeDate,
        CustomerId: parseInt(this.record.CustomerId),
        PaymentModeId: parseInt(this.record.PaymentModeId),
        Narration: this.record.Narration,
        RefNo: this.record.RefNo,
        SelectedIds: selectedIds
      };

      var url = '';
      if (this.PaymentOption == "A") {
        url = "/create-customer-receipt";
      }

      if (this.PaymentOption == "C") {
        url = "/create-customer-receipt-autoclear";
      }

      const self = this;
      self.$store.commit("btnLoader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$router.push("/customer-receipts");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    queryCustomers(searchText) {
      const self = this;
      const url = "/customers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // if array length > 1
            self.customers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    fetchInvoices(id) {
      const self = this;
      this.$store
        .dispatch("get", `/debtor-invoices/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.invoices = res.ResponseData.unclearedInvoices;
            self.currentBalance = res.ResponseData.currentBalance;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    fetchAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    fetchPaymentModes() {
      const self = this;
      this.$store
        .dispatch("get", `/payment-modes`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.paymentModes = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([this.fetchPaymentModes(), this.fetchAccounts()]);
  }
};
</script>